import React, { Fragment } from "react";
import { Paper, withStyles, AppBar, Tabs, Tab, Modal } from '@material-ui/core';
import { Container, Row, Col, Button } from 'react-bootstrap';
import _ from 'lodash';
import autoBind from 'react-autobind';
import { Query, withApollo } from "react-apollo";
import ReactPlayer from 'react-player';

const styles = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minWidth: '1000px'
    },
    tabRoot: {
        padding: '15px',
    },
    gravacoesTableWrapper: {
        marginBottom: '10px'
    },
    videoPlayerWrapper: {},
    buttonsActionWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '0px !important',
        marginTop: '6px'
    },
});

class VideoPlayerPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
        autoBind(this);
    }

    render() {
        const { classes, videoUrl, handleCloseFnc } = this.props;
        return (
            <Paper className={classes.root}>
                <Container>
                    <Row>
                        <Col>
                            <ReactPlayer url={videoUrl} playing controls width='100%' height='100%' />
                        </Col>
                    </Row>
                    <Row>
                        <Col className={classes.buttonsActionWrapper}>
                            <Button variant="primary-get" type="button" onClick={handleCloseFnc}>Fechar</Button>
                        </Col>
                    </Row>
                </Container>
            </Paper>
        );
    }

}

export default withApollo(withStyles(styles)(VideoPlayerPopup));